/*
  The samValueCorrector function takes in a JSON object, obtained from
  the SAM-device-polling-API, and returns a new similar object, where
  specific values have been transformed.

  This transformation is made due to the API multiplying certain values with
  factors of 10 to avoid floating point numbers.

  The logic is extracted from the brain of Olaf Sverre Johansen (olaf.sverre.johansen@get.no)
*/
export default function samValueCorrector(samDevicePolling) {
    var _a, _b;
    const usChannels = ((_a = samDevicePolling === null || samDevicePolling === void 0 ? void 0 : samDevicePolling.UsChannels) !== null && _a !== void 0 ? _a : []).map(ch => (Object.assign(Object.assign({}, ch), { Frequency: ch.Frequency / 100, Power: ch.Power / 10, Snr: ch.Snr / 10 })));
    const dsChannels = ((_b = samDevicePolling === null || samDevicePolling === void 0 ? void 0 : samDevicePolling.DsChannels) !== null && _b !== void 0 ? _b : []).map(ch => (Object.assign(Object.assign({}, ch), { Power: ch.Power / 10, Snr: ch.Snr / 10 })));
    return Object.assign(Object.assign({}, samDevicePolling), { UsChannels: usChannels, DsChannels: dsChannels });
}
